import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 7px;
  height: 27px;
  color: #9b9b9b;
`

const Menu = ({ title = 'Menu', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 7 27" title={title} {...rest}>
    <g fill="currentColor" fillRule="evenodd">
      <circle cx={3.5} cy={3.5} r={3.5} />
      <circle cx={3.5} cy={13.5} r={3.5} />
      <circle cx={3.5} cy={23.5} r={3.5} />
    </g>
  </StyledIcon>
)

Menu.displayName = 'Menu'
Menu.needsWork = true
export default Menu
